export const UTM_CAMPAIGN = 'utmCampaign';
export const UTM_MEDIUM = 'utmMedium';
export const UTM_SOURCE = 'utmSource';
export const UTM_TERM = 'utmTerm';
export const UTM_CONTENT = 'utmContent';
